import React from 'react'

import { Sidebar, SidebarLabel } from './style'

const AboutDevelopersSidebar = () => (
    <Sidebar>
        <SidebarLabel>Информация</SidebarLabel>
    </Sidebar>
)

export default AboutDevelopersSidebar
